import { NgModule } from '@angular/core';
import { SalespersonMultiSelectComponent } from './salesperson-multi-select.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { VaFormsModule } from '@vendasta/forms';
import { SalespersonMultiSelectStoreService } from './salesperson-multi-select.store.service';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { Salesperson } from '@galaxy/types';
import {
  ALL_SALESPEOPLE_TOKEN,
  INIT_WITH_CUR_SALESPERSON_TOKEN,
  SALESPERSON_ID_TOKEN,
  SALESPERSON_MULTI_SELECT_CONFIG_TOKEN,
  SALESPERSON_NAME_TOKEN,
  SalespersonMultiSelectConfig,
} from './tokens';

@NgModule({
  declarations: [SalespersonMultiSelectComponent],
  imports: [CommonModule, ReactiveFormsModule, MatButtonModule, MatDialogModule, TranslateModule, VaFormsModule],
  providers: [
    SalespersonMultiSelectStoreService,
    {
      provide: ALL_SALESPEOPLE_TOKEN,
      deps: [SALESPERSON_MULTI_SELECT_CONFIG_TOKEN],
      useFactory: salespersonFactory,
    },
    {
      provide: SALESPERSON_ID_TOKEN,
      deps: [SALESPERSON_MULTI_SELECT_CONFIG_TOKEN],
      useFactory: salespersonIdFactory,
    },
    {
      provide: SALESPERSON_NAME_TOKEN,
      deps: [SALESPERSON_MULTI_SELECT_CONFIG_TOKEN],
      useFactory: salespersonNameFactory,
    },
    {
      provide: INIT_WITH_CUR_SALESPERSON_TOKEN,
      deps: [SALESPERSON_MULTI_SELECT_CONFIG_TOKEN],
      useFactory: initWithCurSalespersonFactory,
    },
  ],
})
export class SalespersonMultiSelectModule {}

function salespersonFactory(config: SalespersonMultiSelectConfig): Observable<Salesperson[]> {
  return config.allSalespeople$;
}

function salespersonIdFactory(config: SalespersonMultiSelectConfig): Observable<string> {
  return config.salespersonId$;
}

function salespersonNameFactory(config: SalespersonMultiSelectConfig): Observable<string> {
  return config.salespersonName$;
}

function initWithCurSalespersonFactory(config: SalespersonMultiSelectConfig): boolean {
  return config.initWithLoggedInSalesperson;
}
